import { atom } from 'jotai';
import { $CurrentPOIId } from '@poi/shared/current-poi';
import { $POIInfo, $POIPosts } from 'shared/atoms/poi';
import { IPOIInfo, POIInfoUtil } from 'shared/models/poi';

export const $CurrentPOIPosts = atom((get) => {
  const currentPOIId = get($CurrentPOIId);
  return get($POIPosts(currentPOIId));
});
